import { Box, Text } from '@factorialco/deprecated-design-system'
import { EvaluationFormListItemFragment } from 'generated/resources/graphql'

interface Props {
  evaluationForm: EvaluationFormListItemFragment
}

export const DisplayEvaluationForm = ({ evaluationForm }: Props) => {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      background="grey000White"
      paddingY="s8"
      gap="s8"
      gapDivider
    >
      {evaluationForm.questions.map((question) => (
        <Box paddingX="s16" key={question.id} gap="s8">
          <Text.Normal color="grey1000" weight="medium">
            {question.text}
          </Text.Normal>
          <Text.Normal color="grey800">{question.description} </Text.Normal>
        </Box>
      ))}
    </Box>
  )
}
